(function(){
var CSS="#wtg{--bg:#F0FBF6;--bg2:#D0F2E3;--ink:#12302C;--body:#1C3735;--gold:#C4A864;--card:#fff;--line:rgba(18,48,44,.13);--mute:rgba(28,55,53,.62);\n  background:linear-gradient(170deg,var(--bg) 0%,var(--bg2) 100%);color:var(--body);\n  font-family:-apple-system,BlinkMacSystemFont,\"Hiragino Sans\",\"Hiragino Kaku Gothic ProN\",\"Noto Sans JP\",\"Yu Gothic\",sans-serif;\n  line-height:1.8;padding:0 16px 64px;margin:0;width:100%;max-width:100%;overflow-x:hidden;-webkit-font-smoothing:antialiased;box-sizing:border-box}\n#wtg *,#wtg *::before,#wtg *::after{box-sizing:border-box}\n#wtg h1,#wtg h2,#wtg h3{font-family:\"Hiragino Mincho ProN\",\"Yu Mincho\",\"Noto Serif JP\",serif;color:var(--ink);font-weight:600;margin:0;letter-spacing:.02em}\n.wtg-hero{max-width:1080px;margin:0 auto;padding:56px 0 32px;text-align:center}\n.wtg-kicker{margin:0 0 14px;font-size:11px;letter-spacing:.32em;color:var(--gold);font-weight:600}\n.wtg-title{font-size:clamp(28px,5vw,44px);line-height:1.3}\n.wtg-title::after{content:\"\";display:block;width:44px;height:1px;background:var(--gold);margin:18px auto 0}\n.wtg-sub{margin:14px 0 0;font-size:12px;letter-spacing:.2em;color:var(--mute);text-transform:uppercase}\n.wtg-lead{margin:18px auto 0;max-width:620px;font-size:14px;color:var(--mute)}\n.wtg-tools{max-width:1080px;margin:0 auto;position:sticky;top:0;z-index:20;padding:12px 0 10px;\n  background:linear-gradient(180deg,rgba(240,251,246,.97) 70%,rgba(240,251,246,0) 100%);backdrop-filter:blur(6px)}\n.wtg-searchwrap{position:relative;display:flex;align-items:center}\n.wtg-searchicon{position:absolute;left:16px;width:18px;height:18px;fill:none;stroke:var(--mute);stroke-width:1.7;stroke-linecap:round;pointer-events:none}\n.wtg-search{width:100%;padding:14px 44px 14px 44px;border:1px solid var(--line);border-radius:999px;background:var(--card);\n  font-size:15px;color:var(--ink);font-family:inherit;outline:none;transition:border-color .2s,box-shadow .2s}\n.wtg-search::-webkit-search-cancel-button{display:none}\n.wtg-search:focus{border-color:var(--gold);box-shadow:0 0 0 3px rgba(196,168,100,.18)}\n.wtg-clear{position:absolute;right:10px;width:28px;height:28px;border:0;border-radius:50%;background:rgba(18,48,44,.07);\n  color:var(--body);font-size:18px;line-height:1;cursor:pointer}\n.wtg-cats,.wtg-kana{display:flex;flex-wrap:wrap;gap:6px;margin-top:10px}\n.wtg-chip{border:1px solid var(--line);background:rgba(255,255,255,.72);color:var(--body);border-radius:999px;\n  padding:5px 13px;font-size:12.5px;cursor:pointer;font-family:inherit;transition:all .16s;white-space:nowrap}\n.wtg-chip:hover{border-color:var(--gold);color:var(--ink)}\n.wtg-chip[aria-pressed=\"true\"]{background:var(--ink);border-color:var(--ink);color:#fff}\n.wtg-kana .wtg-chip{padding:4px 10px;font-size:12px;min-width:34px;text-align:center}\n.wtg-result{margin:12px 0 0;font-size:12px;color:var(--mute);letter-spacing:.04em}\n.wtg-grid{max-width:1080px;margin:14px auto 0;display:grid;gap:10px;grid-template-columns:repeat(auto-fill,minmax(215px,1fr))}\n.wtg-card{text-align:left;background:var(--card);border:1px solid var(--line);border-radius:12px;padding:15px 16px;cursor:pointer;\n  font-family:inherit;color:var(--body);transition:transform .16s,box-shadow .16s,border-color .16s;display:flex;flex-direction:column;gap:3px}\n.wtg-card:hover{transform:translateY(-2px);box-shadow:0 8px 22px rgba(18,48,44,.09);border-color:rgba(196,168,100,.6)}\n.wtg-card-ja{font-family:\"Hiragino Mincho ProN\",\"Yu Mincho\",\"Noto Serif JP\",serif;font-size:16.5px;color:var(--ink);font-weight:600;line-height:1.45}\n.wtg-card-en{font-size:11.5px;color:var(--mute);letter-spacing:.03em}\n.wtg-card-cat{margin-top:6px;font-size:10.5px;color:var(--gold);letter-spacing:.08em}\n.wtg-empty{max-width:1080px;margin:40px auto;text-align:center;color:var(--mute);font-size:14px}\n.wtg-foot{max-width:1080px;margin:56px auto 0;padding-top:22px;border-top:1px solid var(--line);text-align:center;font-size:11.5px;color:var(--mute)}\n.wtg-modal[hidden]{display:none}\n.wtg-modal{position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:16px}\n.wtg-backdrop{position:absolute;inset:0;background:rgba(18,48,44,.42);backdrop-filter:blur(2px)}\n.wtg-panel{position:relative;background:#fff;border-radius:16px;max-width:620px;width:100%;max-height:86vh;overflow:auto;\n  padding:34px 30px 30px;box-shadow:0 24px 60px rgba(18,48,44,.26);animation:wtgIn .22s ease-out}\n@keyframes wtgIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}}\n.wtg-close{position:absolute;top:12px;right:14px;border:0;background:none;font-size:26px;line-height:1;color:var(--mute);cursor:pointer}\n.wtg-d-cat{margin:0 0 6px;font-size:11px;letter-spacing:.18em;color:var(--gold)}\n.wtg-d-ja{font-size:26px;line-height:1.4}\n.wtg-d-meta{margin:6px 0 0;font-size:12.5px;color:var(--mute)}\n.wtg-d-en{display:block;font-size:13px;letter-spacing:.06em;color:var(--body);margin-top:2px}\n.wtg-d-def{margin:18px 0 0;font-size:14.5px;line-height:2}\n.wtg-d-block{margin-top:26px;padding-top:20px;border-top:1px solid var(--line)}\n.wtg-d-h3{font-size:12px;letter-spacing:.16em;color:var(--mute);margin-bottom:12px;font-family:inherit;font-weight:600}\n.wtg-d-rel{display:flex;flex-wrap:wrap;gap:6px}\n.wtg-d-prod{display:grid;gap:10px;grid-template-columns:repeat(auto-fill,minmax(140px,1fr))}\n.wtg-p{display:block;text-decoration:none;color:var(--body)}\n.wtg-p img{width:100%;aspect-ratio:1/1;object-fit:cover;border-radius:8px;background:var(--bg);display:block}\n.wtg-p-t{font-size:12px;margin:7px 0 0;line-height:1.55;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}\n.wtg-p-pr{font-size:11.5px;color:var(--mute);margin:2px 0 0}\n.wtg-d-more{display:inline-block;margin-top:14px;font-size:12.5px;color:var(--ink);text-decoration:none;border-bottom:1px solid var(--gold);padding-bottom:2px}\n.wtg-loading{font-size:12px;color:var(--mute)}\n@media (max-width:600px){\n  .wtg-hero{padding:38px 0 24px}\n  .wtg-grid{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:8px}\n  .wtg-card{padding:12px 13px}\n  .wtg-card-ja{font-size:15px}\n  .wtg-panel{padding:30px 20px 24px;max-height:92vh}\n  .wtg-kana{max-height:72px;overflow:auto}\n}\n.wtg-card{text-decoration:none}\n.wtg-all{max-width:1080px;margin:64px auto 0;padding-top:34px;border-top:1px solid var(--line)}\n.wtg-all-h{font-size:clamp(20px,3vw,26px);line-height:1.4}\n.wtg-all-note{margin:8px 0 0;font-size:13px;color:var(--mute)}\n.wtg-all-body{margin-top:26px;columns:2;column-gap:34px}\n.wtg-a{break-inside:avoid;page-break-inside:avoid;margin:0 0 22px;padding:0 0 18px;border-bottom:1px solid var(--line)}\n.wtg-a-h{font-size:17px;line-height:1.45;margin:0}\n.wtg-a-h a{color:var(--ink);text-decoration:none;border-bottom:1px solid transparent}\n.wtg-a-h a:hover{border-bottom-color:var(--gold)}\n.wtg-a-m{margin:4px 0 0;font-size:11.5px;color:var(--mute);letter-spacing:.03em}\n.wtg-a-d{margin:9px 0 0;font-size:13.5px;line-height:1.95}\n.wtg-a-r{margin:8px 0 0;font-size:12px;color:var(--mute)}\n.wtg-a-r a{color:var(--body);text-decoration:none;border-bottom:1px dotted var(--gold)}\n@media (max-width:820px){.wtg-all-body{columns:1}}\n";
function boot(){
  if(document.getElementById("wtg")) return;
  var mount=document.getElementById("wtg-mount");
  if(!mount){mount=document.createElement("div");mount.id="wtg-mount";document.body.appendChild(mount);}
  var st=document.createElement("style");st.textContent=CSS;document.head.appendChild(st);
  mount.innerHTML=HTML();
  init();
}

var LANG=(document.documentElement.getAttribute("lang")||"ja").toLowerCase();
var LG=LANG.indexOf("ja")===0?"ja":LANG.indexOf("zh")===0?"zh":LANG.indexOf("ko")===0?"ko":"en";
var EN=LG!=="ja";
var PREFIX=(function(){
  try{
    var r=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
    r=r.replace(/\/+$/,"");
    if(r) return r;
  }catch(e){}
  return {ja:"",en:"/en",zh:"/zh",ko:"/ko"}[LG]||"";
})();

var LL={};
LL.en={
  allTitle:"Full list of terms",
  allNote:"Every entry in the encyclopedia, in one place.",
  title:"Encyclopedia of Watch Terms",
  sub:"時計用語百科事典",
  lead1:"",lead2:" terms and brands for reading a vintage watch.",
  lead3:"From movements, cases and dials to the language of condition and the trade.",
  ph:"Search terms, Japanese or English (e.g. chronograph / patina / lume)",
  aQ:"Search the glossary",aClear:"Clear search",aCat:"Filter by category",
  aIdx:"Filter by initial letter",aClose:"Close",
  empty:"No term matched that search. Please try another word.",
  rel:"Related terms",prod:"Watches in stock whose description uses this term",
  more:"Search all products for this term →",
  loading:"Checking stock…",
  all:"All",
  foot:"WatchTender Ginza — vintage watches of the 1900s to the 2000s, by appointment only",
  result:function(n,t){return "Showing "+n+" of "+t+" terms";}
};
LL.ja={
  allTitle:"全用語一覧",
  allNote:"百科事典の全項目をこのページにまとめています。",
  title:"時計用語百科事典",
  sub:"Encyclopedia of Watch Terms",
  lead1:"ヴィンテージウォッチを読み解くための用語とブランドを",
  lead2:"項目収録。",
  lead3:"機構・外装・文字盤から、状態表現や取引の言葉まで。",
  ph:"用語・英語・説明文から検索（例: クロノグラフ / patina / 夜光）",
  aQ:"用語を検索",aClear:"検索をクリア",aCat:"カテゴリで絞り込み",
  aIdx:"五十音で絞り込み",aClose:"閉じる",
  empty:"該当する用語が見つかりませんでした。別のことばでお試しください。",
  rel:"関連する用語",prod:"この用語が説明文に登場する在庫",
  more:"この用語で商品をすべて検索する →",
  loading:"在庫を確認しています…",
  all:"全",
  foot:"WatchTender 銀座｜1900年代〜2000年代のヴィンテージウォッチ専門　完全予約制",
  result:function(n,t){return n+" 語を表示中　（全 "+t+" 語）";}
};
LL.zh={
  allTitle:"全部术语一览",
  allNote:"本百科的全部条目汇总于此。",
  title:"钟表术语百科",
  sub:"Encyclopedia of Watch Terms",
  lead1:"收录解读古董腕表所需的术语与品牌 ",
  lead2:" 条。",
  lead3:"从机芯、外装、表盘，到品相描述与交易用语。",
  ph:"按术语、英文或释义搜索（例：计时码表 / patina / 夜光）",
  aQ:"搜索术语",aClear:"清除搜索",aCat:"按分类筛选",
  aIdx:"按首字母筛选",aClose:"关闭",
  empty:"没有找到相符的术语。请换一个词试试。",
  rel:"相关术语",prod:"描述中出现该术语的现货",
  more:"以该术语搜索全部商品 →",
  loading:"正在确认库存…",
  all:"全部",
  foot:"WatchTender 银座｜专营 1900—2000 年代古董腕表　完全预约制",
  result:function(n,t){return "显示 "+n+" 条，共 "+t+" 条";}
};
LL.ko={
  allTitle:"전체 용어 목록",
  allNote:"백과사전의 모든 항목을 한곳에 모았습니다.",
  title:"시계 용어 백과사전",
  sub:"Encyclopedia of Watch Terms",
  lead1:"빈티지 워치를 읽어 내기 위한 용어와 브랜드 ",
  lead2:"항목 수록.",
  lead3:"무브먼트・외장・다이얼부터 상태 표현과 거래 용어까지.",
  ph:"용어・영문・설명으로 검색 (예: 크로노그래프 / patina / 야광)",
  aQ:"용어 검색",aClear:"검색 지우기",aCat:"카테고리로 좁히기",
  aIdx:"첫 글자로 좁히기",aClose:"닫기",
  empty:"해당하는 용어를 찾지 못했습니다. 다른 단어로 시도해 주십시오.",
  rel:"관련 용어",prod:"설명에 이 용어가 등장하는 재고",
  more:"이 용어로 전체 상품 검색 →",
  loading:"재고를 확인하고 있습니다…",
  all:"전체",
  foot:"WatchTender 긴자｜1900년대~2000년대 빈티지 워치 전문　완전 예약제",
  result:function(n,t){return "전체 "+t+"개 중 "+n+"개 표시";}
};
var L=LL[LG]||LL.en;

function esc(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;");}

function HTML(){
  return '<div id="wtg" class="wtg">'
  +'<header class="wtg-hero">'
  +'<p class="wtg-kicker">WATCHTENDER GINZA</p>'
  +'<h1 class="wtg-title">'+esc(L.title)+'</h1>'
  +'<p class="wtg-sub">'+esc(L.sub)+'</p>'
  +'<p class="wtg-lead">'+esc(L.lead1)+'<span class="wtg-count-hero"></span>'+esc(L.lead2)+'<br>'+esc(L.lead3)+'</p>'
  +'</header>'
  +'<div class="wtg-tools">'
  +'<div class="wtg-searchwrap">'
  +'<svg class="wtg-searchicon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><line x1="16.5" y1="16.5" x2="21" y2="21"/></svg>'
  +'<input id="wtg-q" class="wtg-search" type="search" placeholder="'+esc(L.ph)+'" autocomplete="off" aria-label="'+esc(L.aQ)+'">'
  +'<button id="wtg-clear" class="wtg-clear" type="button" aria-label="'+esc(L.aClear)+'" hidden>&times;</button>'
  +'</div>'
  +'<div class="wtg-cats" id="wtg-cats" role="group" aria-label="'+esc(L.aCat)+'"></div>'
  +'<div class="wtg-kana" id="wtg-kana" role="group" aria-label="'+esc(L.aIdx)+'"></div>'
  +'<p class="wtg-result" id="wtg-result"></p>'
  +'</div>'
  +'<div class="wtg-grid" id="wtg-grid"></div>'
  +'<p class="wtg-empty" id="wtg-empty" hidden>'+esc(L.empty)+'</p>'
  +'<section class="wtg-all" id="wtg-all" aria-labelledby="wtg-all-h">'
  +'<h2 class="wtg-all-h" id="wtg-all-h">'+esc(L.allTitle)+'</h2>'
  +'<p class="wtg-all-note">'+esc(L.allNote)+'</p>'
  +'<div class="wtg-all-body" id="wtg-all-body"></div>'
  +'</section>'
  +'<div class="wtg-modal" id="wtg-modal" hidden>'
  +'<div class="wtg-backdrop" data-close></div>'
  +'<div class="wtg-panel" role="dialog" aria-modal="true" aria-labelledby="wtg-d-ja">'
  +'<button class="wtg-close" type="button" data-close aria-label="'+esc(L.aClose)+'">&times;</button>'
  +'<p class="wtg-d-cat" id="wtg-d-cat"></p>'
  +'<h2 class="wtg-d-ja" id="wtg-d-ja"></h2>'
  +'<p class="wtg-d-meta"><span id="wtg-d-yomi"></span><span class="wtg-d-en" id="wtg-d-en"></span></p>'
  +'<p class="wtg-d-def" id="wtg-d-def"></p>'
  +'<div class="wtg-d-block" id="wtg-d-relwrap" hidden>'
  +'<h3 class="wtg-d-h3">'+esc(L.rel)+'</h3><div class="wtg-d-rel" id="wtg-d-rel"></div></div>'
  +'<div class="wtg-d-block" id="wtg-d-prodwrap" hidden>'
  +'<h3 class="wtg-d-h3">'+esc(L.prod)+'</h3><div class="wtg-d-prod" id="wtg-d-prod"></div>'
  +'<a class="wtg-d-more" id="wtg-d-more" href="#">'+esc(L.more)+'</a></div>'
  +'</div></div>'
  +'<footer class="wtg-foot"><p>'+esc(L.foot)+'</p></footer>'
  +'</div>';
}

function init(){
(function(){
  var DATA = (window.WT_GLOSSARY || []);
  var CATS_JA = [
    ['all','すべて'],['brand','ブランド'],['movement','ムーブメント・機構'],['complication','複雑機構'],['case','ケース・外装'],
    ['dial','文字盤・針'],['crystal','風防'],['band','ベルト・ブレス'],['material','素材・仕上げ'],
    ['parts','部品'],['standard','精度・規格'],['vintage','状態・ヴィンテージ'],['trade','取引・流通'],['history','歴史・背景']
  ];
  var CATS_EN = [
    ['all','All'],['brand','Brands'],['movement','Movements & mechanics'],['complication','Complications'],['case','Case & exterior'],
    ['dial','Dial & hands'],['crystal','Crystals'],['band','Straps & bracelets'],['material','Materials & finishing'],
    ['parts','Components'],['standard','Accuracy & standards'],['vintage','Condition & vintage'],['trade','Trade & market'],['history','History & background']
  ];
  var CATS_ZH = [
    ['all','全部'],['brand','品牌'],['movement','机芯・机构'],['complication','复杂功能'],['case','表壳・外装'],
    ['dial','表盘・指针'],['crystal','表镜'],['band','表带・表链'],['material','材质・修饰'],
    ['parts','零件'],['standard','精度・规格'],['vintage','品相・古董'],['trade','交易・流通'],['history','历史・背景']
  ];
  var CATS_KO = [
    ['all','전체'],['brand','브랜드'],['movement','무브먼트・기구'],['complication','컴플리케이션'],['case','케이스・외장'],
    ['dial','다이얼・핸즈'],['crystal','글라스'],['band','스트랩・브레이슬릿'],['material','소재・마감'],
    ['parts','부품'],['standard','정확도・규격'],['vintage','상태・빈티지'],['trade','거래・유통'],['history','역사・배경']
  ];
  var CATS = LG==='ja'?CATS_JA:LG==='zh'?CATS_ZH:LG==='ko'?CATS_KO:CATS_EN;
  var CATLABEL={};CATS.forEach(function(c){CATLABEL[c[0]]=c[1];});
  var ROWS=[['あ','あいうえお'],['か','かきくけこがぎぐげご'],['さ','さしすせそざじずぜぞ'],['た','たちつてとだぢづでど'],
            ['な','なにぬねの'],['は','はひふへほばびぶべぼぱぴぷぺぽ'],['ま','まみむめも'],['や','やゆよ'],
            ['ら','らりるれろ'],['わ','わをん']];
  var AZ="ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
  function rowOf(y){var c=(y||'').charAt(0);for(var i=0;i<ROWS.length;i++){if(ROWS[i][1].indexOf(c)>=0)return ROWS[i][0];}return '他';}
  function azOf(e){var c=(e||'').replace(/^[^A-Za-z0-9]+/,'').charAt(0).toUpperCase();return AZ.indexOf(c)>=0?c:'#';}
  function head(t){return LG==='ja'?t.ja:LG==='zh'?(t.headZh||t.en):LG==='ko'?(t.headKo||t.en):t.en;}
  function sortKey(t){return LG==='ja'?t.yomi:(t.en||'').toLowerCase();}
  function defOf(t){if(LG==='zh'&&t.defZh)return t.defZh; if(LG==='ko'&&t.defKo)return t.defKo; if(LG==='en'&&t.defEn)return t.defEn; return t.def;}

  var BYJA={};
  DATA.forEach(function(t){
    t.row=rowOf(t.yomi); t.az=azOf(t.en);
    t._s=(t.ja+' '+t.yomi+' '+t.en+' '+t.def+' '+(t.defEn||'')+' '+(t.headZh||'')+' '+(t.defZh||'')+' '+(t.headKo||'')+' '+(t.defKo||'')).toLowerCase();
    BYJA[t.ja]=t;
  });

  var $=function(id){return document.getElementById(id);};
  var q='',cat='all',row='';
  var elGrid=$('wtg-grid'),elQ=$('wtg-q'),elRes=$('wtg-result'),elEmpty=$('wtg-empty');
  var hero=document.querySelector('.wtg-count-hero'); if(hero) hero.textContent=DATA.length;

  function chip(label,pressed,on){
    var b=document.createElement('button');b.type='button';b.className='wtg-chip';
    b.setAttribute('aria-pressed',pressed?'true':'false');b.textContent=label;b.addEventListener('click',on);return b;
  }
  function buildChips(){
    var cc=$('wtg-cats');cc.innerHTML='';
    CATS.forEach(function(c){cc.appendChild(chip(c[1],cat===c[0],function(){cat=c[0];buildChips();render();}));});
    var kk=$('wtg-kana');kk.innerHTML='';
    kk.appendChild(chip(L.all,row==='',function(){row='';buildChips();render();}));
    if(EN){
      AZ.forEach(function(c){kk.appendChild(chip(c,row===c,function(){row=(row===c?'':c);buildChips();render();}));});
    }else{
      ROWS.forEach(function(r){kk.appendChild(chip(r[0],row===r[0],function(){row=(row===r[0]?'':r[0]);buildChips();render();}));});
    }
  }
  function match(t){
    if(cat!=='all'&&t.cat!==cat)return false;
    if(row&&(EN?t.az:t.row)!==row)return false;
    if(!q)return true;
    return t._s.indexOf(q)>=0;
  }
  function score(t){
    if(!q)return 0;
    var ja=t.ja.toLowerCase(),en=t.en.toLowerCase(),yo=t.yomi;
    if(ja===q||en===q)return 0;
    if(EN){
      if(en.indexOf(q)===0)return 1;
      if(ja.indexOf(q)===0||yo.indexOf(q)===0)return 2;
      if(en.indexOf(q)>=0)return 3;
      if(ja.indexOf(q)>=0||yo.indexOf(q)>=0)return 4;
      return 5;
    }
    if(ja.indexOf(q)===0||yo.indexOf(q)===0||en.indexOf(q)===0)return 1;
    if(ja.indexOf(q)>=0||yo.indexOf(q)>=0)return 2;
    if(en.indexOf(q)>=0)return 3;
    return 4;
  }
  function render(){
    var list=DATA.filter(match);
    list.sort(function(a,b){
      var d=score(a)-score(b); if(d)return d;
      var ka=sortKey(a),kb=sortKey(b);
      return ka<kb?-1:ka>kb?1:0;
    });
    elGrid.innerHTML='';
    var frag=document.createDocumentFragment();
    list.forEach(function(t){
      var b=document.createElement('a');b.className='wtg-card';
      b.href=location.pathname+'?term='+encodeURIComponent(t.ja);
      var j=document.createElement('span');j.className='wtg-card-ja';j.textContent=head(t);
      var e=document.createElement('span');e.className='wtg-card-en';e.textContent=LG==='ja'?t.en:(LG==='en'?t.ja:t.ja+'  '+t.en);
      var c=document.createElement('span');c.className='wtg-card-cat';c.textContent=CATLABEL[t.cat]||'';
      b.appendChild(j);b.appendChild(e);b.appendChild(c);
      b.addEventListener('click',function(ev){
        if(ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.button===1) return;
        ev.preventDefault(); open(t.ja);
      });
      frag.appendChild(b);
    });
    elGrid.appendChild(frag);
    elRes.textContent=L.result(list.length,DATA.length);
    elEmpty.hidden=list.length>0;
  }
  elQ.addEventListener('input',function(){q=elQ.value.trim().toLowerCase();$('wtg-clear').hidden=!q;render();});
  $('wtg-clear').addEventListener('click',function(){elQ.value='';q='';$('wtg-clear').hidden=true;render();elQ.focus();});

  var modal=$('wtg-modal'),lastFocus=null,currentTerm=null;
  function open(ja){
    var t=BYJA[ja];if(!t)return;
    currentTerm=t.ja;
    if(modal.hidden) lastFocus=document.activeElement;
    $('wtg-d-cat').textContent=CATLABEL[t.cat]||'';
    $('wtg-d-ja').textContent=head(t);
    $('wtg-d-yomi').textContent=LG==='ja'?t.yomi:t.ja;
    $('wtg-d-en').textContent=LG==='ja'?t.en:(LG==='en'?'':t.en);
    $('wtg-d-def').textContent=defOf(t);
    var rw=$('wtg-d-relwrap'),rl=$('wtg-d-rel');rl.innerHTML='';
    var rels=(t.rel||[]).filter(function(r){return !!BYJA[r];});
    rels.forEach(function(r){rl.appendChild(chip(head(BYJA[r]),false,function(){open(r);}));});
    rw.hidden=rels.length===0;
    modal.hidden=false;document.body.style.overflow='hidden';
    modal.querySelector('.wtg-panel').scrollTop=0;
    $('wtg-d-ja').setAttribute('tabindex','-1');$('wtg-d-ja').focus();
    if(history.replaceState)history.replaceState(null,'','?term='+encodeURIComponent(t.ja));
    products(t);
  }
  function close(){
    currentTerm=null;modal.hidden=true;document.body.style.overflow='';
    if(history.replaceState)history.replaceState(null,'',location.pathname);
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
    lastFocus=null;
  }
  modal.addEventListener('click',function(e){if(e.target.hasAttribute('data-close'))close();});
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&!modal.hidden)close();
    if(e.key==='/'&&document.activeElement!==elQ&&modal.hidden){e.preventDefault();elQ.focus();}
  });

  var pcache={};
  function money(c){try{return '¥'+Number(c/100).toLocaleString({ja:'ja-JP',en:'en-US',zh:'zh-CN',ko:'ko-KR'}[LG]||'en-US');}catch(e){return '';}}
  function thumb(u){ if(!u)return ''; if(u.indexOf('//')===0)u='https:'+u; return u + (u.indexOf('?')>=0?'&':'?') + 'width=300'; }
  function strip(h){ var d=document.createElement('div'); d.innerHTML=h||''; return d.textContent||''; }
  function esc2(s){return s.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}

  function queryTerm(t){
    if(LG==='ja') return t.ja;
    if(LG==='zh'){ var z=(t.headZh||'').split(/[ \u3000]/)[0].trim(); if(z&&z.length>=2) return z; }
    if(LG==='ko'){ var k=(t.headKo||'').split(/[ \u3000]/)[0].trim(); if(k&&k.length>=2) return k; }
    var e=(t.en||'').split('/')[0].replace(/\s*\(.*?\)\s*/g,'').trim();
    return e||t.ja;
  }
  function hit(hay,term){
    if(LG!=='en') return hay.indexOf(term)>=0;
    try{ return new RegExp('(^|[^A-Za-z])'+esc2(term)+'([^A-Za-z]|$)','i').test(hay); }
    catch(e){ return hay.toLowerCase().indexOf(term.toLowerCase())>=0; }
  }

  function candidates(term){
    return fetch(PREFIX+'/search?q='+encodeURIComponent(term)+'&type=product').then(function(r){
      if(!r.ok) throw 0; return r.text();
    }).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var seen={},list=[];
      var as=doc.querySelectorAll('a[href*="/products/"]');
      for(var i=0;i<as.length && list.length<16;i++){
        var href=as[i].getAttribute('href')||'';
        var m=href.match(/(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/products\/[^?#]+/i); if(!m) continue;
        var u=m[0];
        if(u.indexOf(PREFIX+'/products/')!==0){ u=PREFIX+u.replace(/^.*(\/products\/)/,'$1'); }
        if(seen[u]) continue; seen[u]=1;
        list.push(u);
      }
      return list;
    });
  }

  function verify(handles, term){
    return Promise.all(handles.map(function(h){
      return fetch(h+'.js',{headers:{'Accept':'application/json'}}).then(function(r){
        return r.ok?r.json():null;
      }).then(function(j){
        if(!j) return null;
        if(j.available===false) return null;
        var hay=(j.title||'')+' '+strip(j.description||'');
        if(!hit(hay,term)) return null;
        return {url:h, title:j.title||'', img:(j.featured_image||''), price:(typeof j.price==='number')?money(j.price):''};
      }).catch(function(){return null;});
    })).then(function(rows){
      return rows.filter(Boolean).slice(0,6);
    });
  }

  function products(t){
    var wrap=$('wtg-d-prodwrap'),box=$('wtg-d-prod'),more=$('wtg-d-more');
    if(location.protocol==='file:'){wrap.hidden=true;return;}
    var term=queryTerm(t);
    var key=t.ja;
    more.href=PREFIX+'/search?q='+encodeURIComponent(term)+'&type=product';
    if(pcache[key]){paint(pcache[key]);return;}
    wrap.hidden=false;box.innerHTML='<p class="wtg-loading">'+esc(L.loading)+'</p>';
    candidates(term).then(function(hs){ return verify(hs, term); })
      .then(function(items){
        pcache[key]=items||[];
        if(key===currentTerm) paint(pcache[key]);
      })
      .catch(function(){ if(key===currentTerm) wrap.hidden=true; });

    function paint(items){
      if(key!==currentTerm) return;
      if(!items.length){wrap.hidden=true;return;}
      wrap.hidden=false;box.innerHTML='';
      items.forEach(function(p){
        var a=document.createElement('a');a.className='wtg-p';a.href=p.url;
        if(p.img){var im=document.createElement('img');im.src=thumb(p.img);im.alt=p.title||'';im.loading='lazy';a.appendChild(im);}
        var ti=document.createElement('p');ti.className='wtg-p-t';ti.textContent=p.title||'';a.appendChild(ti);
        if(p.price){var pr=document.createElement('p');pr.className='wtg-p-pr';pr.textContent=p.price;a.appendChild(pr);}
        box.appendChild(a);
      });
    }
  }

  /* ---- Full reference list: every definition lives in the DOM, always.
         This is what search engines and other dealers actually read. ---- */
  function slugOf(t){ return 'term-'+DATA.indexOf(t); }
  function buildAll(){
    var box=$('wtg-all-body'); if(!box) return;
    var ordered=DATA.slice().sort(function(a,b){
      var ka=sortKey(a),kb=sortKey(b); return ka<kb?-1:ka>kb?1:0;
    });
    var frag=document.createDocumentFragment();
    ordered.forEach(function(t){
      var art=document.createElement('article');
      art.className='wtg-a'; art.id=slugOf(t);
      var h=document.createElement('h3'); h.className='wtg-a-h';
      var a=document.createElement('a');
      a.href=location.pathname+'?term='+encodeURIComponent(t.ja);
      a.textContent=head(t);
      a.addEventListener('click',function(ev){
        if(ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.button===1) return;
        ev.preventDefault(); open(t.ja);
      });
      h.appendChild(a);
      var meta=document.createElement('p'); meta.className='wtg-a-m';
      var bits=[];
      if(LG!=='ja') bits.push(t.ja);
      if(LG!=='en') bits.push(t.en);
      if(LG==='ja') bits.push(t.yomi);
      bits.push(CATLABEL[t.cat]||'');
      meta.textContent=bits.filter(Boolean).join('　/　');
      var d=document.createElement('p'); d.className='wtg-a-d'; d.textContent=defOf(t);
      art.appendChild(h); art.appendChild(meta); art.appendChild(d);
      var rels=(t.rel||[]).filter(function(r){return !!BYJA[r];});
      if(rels.length){
        var rp=document.createElement('p'); rp.className='wtg-a-r';
        rp.appendChild(document.createTextNode(L.rel+'： '));
        rels.forEach(function(r,i){
          if(i) rp.appendChild(document.createTextNode('、'));
          var ra=document.createElement('a');
          ra.href=location.pathname+'?term='+encodeURIComponent(r);
          ra.textContent=head(BYJA[r]);
          ra.addEventListener('click',function(ev){
            if(ev.metaKey||ev.ctrlKey||ev.shiftKey||ev.button===1) return;
            ev.preventDefault(); open(r);
          });
          rp.appendChild(ra);
        });
        art.appendChild(rp);
      }
      frag.appendChild(art);
    });
    box.appendChild(frag);
  }

  function buildJsonLd(){
    if(document.getElementById('wtg-jsonld')) return;
    var base=location.origin+location.pathname;
    var setId=base+'#glossary';
    var items=DATA.map(function(t){
      var o={
        "@type":"DefinedTerm",
        "@id":base+'?term='+encodeURIComponent(t.ja)+'#'+slugOf(t),
        "name":head(t),
        "description":defOf(t),
        "url":base+'?term='+encodeURIComponent(t.ja),
        "inDefinedTermSet":setId
      };
      var alt=[]; if(LG!=='ja') alt.push(t.ja); if(LG!=='en'&&t.en) alt.push(t.en);
      if(alt.length) o.alternateName=alt;
      if(CATLABEL[t.cat]) o.termCode=t.cat;
      return o;
    });
    var data={
      "@context":"https://schema.org",
      "@type":"DefinedTermSet",
      "@id":setId,
      "name":L.title,
      "description":L.allNote,
      "url":base,
      "inLanguage":LG,
      "publisher":{"@type":"Organization","name":"WatchTender","url":location.origin},
      "hasDefinedTerm":items
    };
    var sc=document.createElement('script');
    sc.type='application/ld+json'; sc.id='wtg-jsonld';
    sc.textContent=JSON.stringify(data);
    (document.head||document.documentElement).appendChild(sc);
  }

  buildChips();render();buildAll();buildJsonLd();
  var m=location.search.match(/[?&]term=([^&]+)/);
  if(m){try{open(decodeURIComponent(m[1]));}catch(e){}}
  window.WTG_OPEN=open;
})();
}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot);}else{boot();}
})();
